import styled from 'styled-components';

export const StyledProgressButtonHolder = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
`